import styled from "styled-components";

export const StyledTitleBar = styled.div`
  width: 100%;
  height: 2.6rem;
  display: flex;
  align-items: center;
  -webkit-app-region: drag;
  background-color: rgb(7, 7, 7);
  & > .info-wrap {
    /* padding: 0.8rem 1.2rem 0 1.2rem; */
    padding-right: 1.2rem;
    display: flex;
    gap: 0.6rem;
    margin: 0 auto;
    align-items: center;
    .title {
      font: var(--label-small-600);
      color: var(--text-gray-normal);
    }
    .info {
      display: flex;
      gap: 0.4rem;
      & > div {
        background-color: var(--bg-gray-3);
        padding: 0 0.4rem;
        border-radius: 0.4rem;
        height: 1.6rem;
        display: flex;
        align-items: center;
        & > p {
          font: var(--label-small-400);
          color: var(--text-gray-strong);
          & > span {
            font: var(--label-small-600);
          }
        }
      }
    }
  }
`;
